/* Thin dashboard wrappers that render existing public pages in "embedded"
   mode (no SiteNav / no SiteFooter / no floating Back button).  Lets
   members bounce between Market, Academy, The Book, Pricing, Walk,
   Jukebox, Coloring Pages, Directory, and Mike's Story WITHOUT leaving
   the back office. */

import MarketPage from "../../pages/MarketPage";
import TrainingHubPage from "../../pages/TrainingHubPage";
import TrainingCoursePage from "../../pages/TrainingCoursePage";
import AffiliateMarketing101Page from "../../pages/AffiliateMarketing101Page";
import WithFaithBookPage from "../../pages/WithFaithBookPage";
import Pricing from "../../pages/Pricing";
import WalkPage from "../../pages/WalkPage";
import JukeboxPage from "../../pages/JukeboxPage";
import ColoringPagesPage from "../../pages/ColoringPagesPage";
import DirectoryPage from "../../pages/DirectoryPage";
import FounderStory from "../../pages/FounderStory";

export const MarketTab        = () => <MarketPage embedded />;
export const AcademyTab       = () => <TrainingHubPage embedded />;
export const AcademyCourseTab = () => <TrainingCoursePage embedded />;
export const Affiliate101Tab  = () => <AffiliateMarketing101Page embedded />;
export const BookTab          = () => <WithFaithBookPage embedded />;
export const PricingTab       = () => <Pricing embedded />;
export const WalkTab          = () => <WalkPage embedded />;
export const JukeboxTab       = () => <JukeboxPage embedded />;
export const ColoringPagesTab = () => <ColoringPagesPage embedded />;
export const DirectoryTab     = () => <DirectoryPage embedded />;
export const FounderTab       = () => <FounderStory embedded />;
